import React, { Component } from 'react';

import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';

import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Elevation } from 'rmwc/Elevation';
import { LinearProgress } from 'rmwc/LinearProgress';
import { Snackbar } from 'rmwc/Snackbar';


import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'

class ReviewUpload extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
    };

    
  }

  componentDidMount() {
  

  }

  

  render() {

    let uploadStatus = this.props.uploadStatus
    let artifactURL = this.props.artifactURL
    let componentToShow
        
    if(uploadStatus === 'no'){
      componentToShow =(
        <form style={{width: '100%'}}>
          <Grid className="opportunity-list-item"> 
            <GridCell span="1">
              <FormField className="opportunity-form-field">
                <Typography use="subtitle2">{this.props.count}.</Typography>
              </FormField>
            </GridCell>         
            <GridCell span="4">
              <FormField className="opportunity-form-field">
                  <Typography use="subtitle2">{this.props.name}</Typography>
              </FormField>
            </GridCell>
            <GridCell span="4">
              <FormField className="opportunity-form-field">
                  <div>
                    <Typography use="subtitle4">No Submissions yet</Typography>
                  </div>
              </FormField>
            </GridCell>       
          </Grid>
        </form>
        )
    }
    else if(uploadStatus === 'yes'){
      componentToShow =(
        <form style={{width: '100%'}}>
          <Grid className="opportunity-list-item">          
            <GridCell span="1">
              <FormField className="opportunity-form-field">
                <Typography use="subtitle2">{this.props.count}.</Typography>
              </FormField>
            </GridCell> 
            <GridCell span="4">
              <FormField className="opportunity-form-field">
                <Typography use="subtitle2">{this.props.name}</Typography>
              </FormField>
            </GridCell>
            <GridCell span="4">
                <FormField className="opportunity-form-field">
                   <a href={artifactURL} target="_blank">View Submission</a> 
                </FormField>   
            </GridCell>                 
          </Grid>
        </form>
        ) 
    }
    
     return (
      
        <GridCell span="12">
          <Elevation z='4'>
            {componentToShow}
             <StatusMessage error_msg = {this.state.errorMsg}/>
          </Elevation>
        </GridCell>
        
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewUpload);



// WEBPACK FOOTER //
// ./src/views/reviewer/ReviewUpload.jsx